import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import { LOCALE_PREFIX } from './constants'

import './style.scss'

export default class ReasonCell extends Component {
    static propTypes = {
        reason: PropTypes.string.isRequired,
    }

    render() {
        const { reason } = this.props

        return (
            <div className={'import-group-result-reason-cell'}>
                <FormattedMessage id={`${LOCALE_PREFIX}.${reason}`} />
            </div>
        )
    }
}
